import React from "react";

const IPO = () => {
  return <div>IPO</div>;
};

export default IPO;
